import League from "../../entities/League.js";

const softballLeague = function(league) {
    return (league instanceof League) && (
        league.sportType === 'Softball_Fastpitch'
        || league.sportType === 'Softball_Slowpitch'
    );
};

export default softballLeague;